// extracted by mini-css-extract-plugin
export default {"Page":"forbidden_page_Page__Oc2U5","PageContent":"forbidden_page_PageContent__gjaBI"};